var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDots = function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 10.1 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.1 58.5c2 0 3.6-1.6 3.6-3.6s-1.6-3.6-3.6-3.6-3.6 1.6-3.6 3.6 1.6 3.6 3.6 3.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 60C2.3 60 0 57.7 0 54.9s2.3-5.1 5.1-5.1 5.1 2.3 5.1 5.1S7.8 60 5.1 60zm0-7.1C4 52.9 3 53.8 3 55c0 1.1.9 2 2.1 2s2.1-.9 2.1-2.1c-.1-1.1-1-2-2.1-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.1,8.6C7,8.6,8.6,7,8.6,5S7,1.5,5.1,1.5c-2,0-3.6,1.6-3.6,3.6S3.1,8.6,5.1,8.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 10.1c-2.8 0-5.1-2.3-5.1-5C0 2.3 2.3 0 5.1 0s5.1 2.3 5.1 5.1c-.1 2.7-2.4 5-5.1 5zm0-7.1C3.9 3 3 3.9 3 5.1c0 1.1.9 2.1 2.1 2.1s2.1-.9 2.1-2.1C7.1 3.9 6.2 3 5.1 3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.1 33.6c2 0 3.6-1.6 3.6-3.6s-1.6-3.6-3.6-3.6S1.5 28 1.5 30s1.6 3.6 3.6 3.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 35.1C2.3 35.1 0 32.8 0 30s2.3-5.1 5.1-5.1 5.1 2.3 5.1 5.1-2.4 5.1-5.1 5.1zm0-7.2c-1.2 0-2.1 1-2.1 2.1s.9 2.1 2.1 2.1 2.1-.9 2.1-2.1-1-2.1-2.1-2.1z"
  })));
};
export default SvgDots;